import { Box, Divider, Link, SvgIcon, Typography } from '@mui/material';
import AttentionRequired from '../../../../../frontend/static/error/AttentionRequired.svg';
import { FIN_OPS_EMAIL, INSTALLER_TYPES } from '../../../constants';
import { useAuth } from '../../../hooks';
import { BankingForm } from './BankingForm';
import { ChangePasswordForm } from './ChangePasswordForm';
import { UserProfileForm } from './UserProfileForm';

export const UserSettings = () => {
  const { user, account } = useAuth();
  const missingBankInfo = !(
    account.installer_bank_account_name &&
    account.installer_bank_account_number &&
    account.installer_bank_routing_number &&
    account.installer_bank_name &&
    account.location_of_bank
  );

  const isInstallerAccount =
    user.is_installer &&
    (user.installer_role === INSTALLER_TYPES.ADMIN ||
      user.installer_role === INSTALLER_TYPES.ACCOUNTING);
  const isConsultantAccount = user.is_consultant;
  const showBankingInfo = isInstallerAccount || isConsultantAccount;

  return (
    <Box flex={1} px={6} py={4}>
      {missingBankInfo && showBankingInfo && (
        <Box display="inline-flex" alignItems="center" mb={4}>
          <SvgIcon component={AttentionRequired} />
          <Typography variant="body1" sx={{ paddingLeft: '8px' }}>
            <b>Action Required:</b> Please add your{' '}
            <Link href="#bankingInfo" sx={{ textDecoration: 'none' }}>
              bank information.
            </Link>
          </Typography>
        </Box>
      )}

      <Typography variant="h1">Profile</Typography>
      <UserProfileForm />
      <Divider sx={{ mt: 2, mb: 6 }} />

      <Typography variant="h1">Account</Typography>
      <ChangePasswordForm />

      {showBankingInfo && (
        <>
          <Divider sx={{ mt: 2, mb: 6 }} />
          <Typography variant="h1" id="bankingInfo">
            Banking Information
          </Typography>
          <BankingForm />

          {!missingBankInfo && (
            <Typography
              variant="body1"
              sx={{ marginTop: '25px', flexGrow: 1, textAlign: 'center' }}
            >
              If you would like to make changes to your banking information,
              please contact{' '}
              <Link
                sx={{ textDecoration: 'none' }}
                href={`mailto:${FIN_OPS_EMAIL}`}
              >
                {FIN_OPS_EMAIL}
              </Link>
            </Typography>
          )}
        </>
      )}
    </Box>
  );
};
